// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import simpleParallax from 'simple-parallax-js';

( function( $ ) {
$.noConflict();

$.fn.extend({
  setequal: function( ){
  //var defaults = { findclass: '' };
  //var o = $.extend(defaults, options);

  //var c = o.findclass;
  // Get an array of all element heights
  var elementHeights = $(this).map(function() {
  return $(this).height();
  }).get();

  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var maxHeight = Math.max.apply(null, elementHeights);

  $(this).height(maxHeight);

  return this;
  }
});

// AOS.init({disable: 'mobile'});

$( ".menu-trigger" ).click(function(e) {
  e.preventDefault();
  $(this).stop().toggleClass('triggered');
  $('header').stop().toggleClass('mobile-header');
  // $('.site-menu-area').stop().slideToggle(200);
  $('.site-menu-area').stop().toggleClass('active');
  // $('.menu-main-menu-container').stop().toggleClass('over-flow');
  // $('header').stop().toggleClass('menu-open');
  $('body').stop().toggleClass('unscroll');
});

$( ".menu-selector" ).click(function(e) {
  e.preventDefault();
  $(this).stop().toggleClass('triggered');
  $('.all-menu').stop().toggleClass('open').stop().fadeToggle(300);
  $('.site-menu-area').stop().fadeToggle(300);
  $('body').stop().toggleClass('unscroll');
});

// Referral Button Trigger
$(".gform_wrapper").change(function(){
  $( ".form-prev-btn" ).click(function(e) {
    e.preventDefault();
    $("#gform_previous_button_2").trigger("click");
  });
});

$('.read-btn').click(function() {
  // $(this).siblings().stop().slideToggle();
  var el = $(this).siblings(),
  curHeight = el.height(),
  autoHeight = el.css('height', 'auto').height();
  
  if ($(this).text() == "Read less") {
    $(this).text("Read more");
    autoHeight = el.css('height', '93px').height();
    el.height(curHeight).animate({height: autoHeight}, 300);
  } else {
    $(this).text("Read less");
    el.height(curHeight).animate({height: autoHeight}, 300);
  }
});

$('.desc-read .in').each(function(){
  if ($(this).height() < 97) {
    $(this).parent().siblings().stop().hide();
  } else {
    $(this).parent().siblings().stop().show();
  }
});

$( ".learn-more-btn" ).click(function(e) {
  e.preventDefault();
  $(this).stop().toggleClass('triggered');
  $(this).siblings().stop().slideToggle();
});

$( ".all-menu .menu-item .top-menu-item.with-sub-level" ).click(function(e) {
  e.preventDefault();
  var hreftar = $(this).attr('href');
  // $(hreftar).stop().addClass('selected');
  $(hreftar).stop().fadeIn(100);
  $('.all-menu .menu-item').stop().fadeOut(100);
  // $(this).siblings().stop().slideToggle();
});

$( ".all-menu .second-menu-item.with-sub-level" ).click(function(e) {
  e.preventDefault();
  var hreftar = $(this).attr('href');
  // $(hreftar).stop().addClass('selected');
  $(hreftar).stop().fadeIn(100);
  $('.all-menu .main .menu-item-sub .sub-menu-1 .sub-menu-item-1').stop().fadeOut(100);
  $('.all-menu .back1').stop().fadeOut(100);
  // $(this).siblings().stop().slideToggle();
});

$( ".all-menu .back1" ).click(function(e) {
  e.preventDefault();
  // var hreftar = $(this).attr('href');
  $('.all-menu .menu-item').stop().fadeIn(100);
  // $('.all-menu .menu-item-sub').stop().removeClass('selected');
  $('.all-menu .menu-item-sub').stop().fadeOut(100);
  // $(this).siblings().stop().slideToggle();
});

$( ".all-menu .back2" ).click(function(e) {
  e.preventDefault();
  // var hreftar = $(this).attr('href');
  $('.all-menu .main .menu-item-sub .sub-menu-1 .sub-menu-item-1').stop().fadeIn(100);
  $('.all-menu .back1').stop().fadeIn(100);
  // $('.all-menu .menu-item-sub-2').stop().removeClass('selected');
  $('.all-menu .menu-item-sub-2').stop().fadeOut(100);
  // $(this).siblings().stop().slideToggle();
});

$(".gform_wrapper select").change(function(){
if (this.value === "") {
     if (!this.classList.contains('placeholder')) {
        this.classList.add('placeholder');
   }
     if (this.classList.contains('others')) {
        this.classList.remove('others');
   }
} else {
     if (!this.classList.contains('others')) {
        this.classList.add('others');
   }
     if (this.classList.contains('placeholder')) {
        this.classList.remove('placeholder');
   }
}
});

var jobSlider = new Swiper(".job-slider", {
  loop:true,
  slidesPerView:4,
  spaceBetween: 30,
  breakpoints: {
    320: {
      slidesPerView:1,
    },
    767: {
      slidesPerView:2,
    },
    991: {
      slidesPerView:3,
    },
    1400: {
      slidesPerView:4,
    },
  },
  pagination: {
    el: '.job-pagination',
    clickable: true,
  },
});

const swiperService = new Swiper('.service-slider', {
  slidesPerView:2,
  spaceBetween: 40,
  breakpoints: {
    320: {
      slidesPerView:1.2,
    },
    767: {
      slidesPerView:2,
    },
  },
  pagination: {
    el: '.service-pagination',
    type: 'custom',
    renderCustom: function (swiper, current, total) {
        return current + '/' + (total); 
    }
  },
  navigation: {
    nextEl: '.service-next',
    prevEl: '.service-prev',
  },
  scrollbar: {
    el: '.service-scrollbar',
    draggable: true,
  },
});

const swiperNews = new Swiper('.news-slider', {
  slidesPerView:2,
  spaceBetween: 40,
  autoHeight:false,
  breakpoints: {
    320: {
      slidesPerView:1,
    },
    767: {
      slidesPerView:2,
    },
  },
  pagination: {
    el: '.news-pagination',
    type: 'custom',
    renderCustom: function (swiper, current, total) {
        return current + '/' + (total); 
    }
  },
  navigation: {
    nextEl: '.news-next',
    prevEl: '.news-prev',
  },
  scrollbar: {
    el: '.news-scrollbar',
    draggable: true,
  },
});

var dash = document.getElementsByClassName('dash-car');
  new simpleParallax(dash, {
  orientation: 'right',
  delay: 0.5,
  overflow: true,
  scale:2
});

if ($(window).width() < 767) {
  $( "footer .inner .middle .lbl" ).click(function(e) {
    e.preventDefault();
    $(this).stop().toggleClass('active').siblings().stop().slideToggle();
  });
   
}


var scroll = $(window).scrollTop();
if (scroll >= 60) {
    $('header').addClass("scrolled");
} else {
    $('header').removeClass("scrolled");
}

/**
 * Script On Document Ready
 */
 $(document).on('scroll', function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 60) {
        $('header').addClass("scrolled");
    } else {
        $('header').removeClass("scrolled");
    }
});

/**
 * Script On Load
 */
$( window ).load( function() {
   $('.slider-news .item h4').setequal();
   $('.slider-news .item .text-cnt').setequal();

} );

/**
 * Script On Resize
 */
$(window).on('resize', function(){
    $('.slider-news .item h4').css('height','auto');
    $('.slider-news .item h4').setequal();
    $('.slider-news .item .text-cnt').css('height','auto');
    $('.slider-news .item .text-cnt').setequal();
    if ($(window).width() >= 1200) {
        $('header').stop().removeClass('mobile-header');
        $('body').stop().removeClass('unscroll');
        $('.menu-trigger').stop().removeClass('triggered');
        $('.site-menu-area').stop().removeAttr( 'style' );
        $('.site-menu-area').stop().removeClass('active');
    }

    $('.desc-read .in').each(function(){
      if ($(this).height() < 97) {
        $(this).parent().siblings().stop().hide();
      } else {
        $(this).parent().siblings().stop().show();
      }
    });
} );
    
    
} ) ( jQuery )